<div class="image-preview__container-img ms-4">
    <img class="image-preview__img" [src]="imagePath" alt="img-preview">
    <div *ngIf="!showCropper" class="image-preview__img-text-centered image-preview__upload-img">
        <div (click)="openAddImage()" class="d-flex flex-row">
            <div class="d-flex flex-column">
                <div style="font-size:60px; text-shadow: 2px 2px 4px #000000;" class="pi pi-image"></div>
                <div style="text-shadow: 2px 2px 4px #000000;">{{ 'INFO.UPLOAD_IMAGE'|translate}}<span> +</span></div>
            </div>
        </div>
    </div>
    <div *ngIf="showCropper" class="image-preview__img-text-top-right image-preview__upload-img">
        <div (click)="openAddImage()" class="d-flex flex-row">
            <div class="d-flex flex-column">
                <div style="font-size:32px; text-shadow: 2px 2px 4px #000000;" class="pi pi-image"></div>
            </div>
        </div>
    </div>
</div>
<input style="display: none;" type="text" #eventImagePath />
<input (change)="onSelectFile($event)" class="open-file" style="display: none;" type="file" id="openFile" #openFile
    name="openFile" accept="image/png, image/jpg, image/jpeg" />
<label class="pictureError ms-4" *ngIf="pictureIsWrongFormat">{{ 'VENUES.PICTURE_IS_WRONG_FORMAT'|translate}}</label>
<image-cropper class="cropper-container ms-4" 
    [imageChangedEvent]="imageChangedEvent" 
    [maintainAspectRatio]="true"
    [aspectRatio]="3 / 0.9" 
    (imageCropped)="imageCropped($event)" 
    (imageLoaded)="imageLoaded()"
    (cropperReady)="cropperReady()" 
    (loadImageFailed)="loadImageFailed()"
    backgroundColor="white"
    [style.display]="showCropper ? null : 'none'">
</image-cropper>
<div class="d-flex flex-row mt-4 justify-content-center align-items-center">
    <button [disabled]="!canSave" class="btn_in_color ms-4 me-4" type="button" (click)="save()">{{'SAVE' | translate}}</button>
    <button class="btn_without_color ms-4 me-4" type="button" (click)="cancel()">{{'CANCEL' | translate}}</button>
</div>